import gameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import Spin from "slotworks/state-machine/standard/states/spin";
import BetModel from "slotworks/model/bets/bet-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import backgroundTint from "components/show-win-lines/background-tint";

export class SGSpin extends Spin {
    private noWinSpin: number = 0;
    
    public onEnter(): void {
        backgroundTint.hide();
        super.onEnter();
    }

    public onExit(): void {
        this.playWinDependentSound();
        super.onExit();
    }

    private playWinDependentSound(): void {
        const cashWon = gameState.getCurrentGame().getCurrentRecord().cashWon;
        const stake = BetModel.getTotalStake();
        if (!this.isFreeSpin()) {
            if (cashWon === 0) {
                this.noWinSpin++;
                if (this.noWinSpin >= 5) {
                    this.noWinSpin = 0;
                    Services.sound.customEvent("five_no_win");
                }
                return;
            }
            if (cashWon > stake) {
                this.noWinSpin = 0;
                Services.sound.customEvent("more_than_stake_win");
            }
            if (cashWon >= stake * 10) {
                Services.sound.customEvent("base-game-winning");
            }
        }
    }

    private isFreeSpin(): boolean {
        const record = gameState.getCurrentGame().getCurrentRecord();
        return record instanceof FreespinRecord;
    }
}
